(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .service('modalService', modalService);

    modalService.$inject = ['$uibModal', '$rootScope'];

    function modalService($modal) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            modalFade: true,
            templateUrl: '/app/manage/views/player.html'
        };

        var modalOptions = {
            closeButtonText: 'Close',
            actionButtonText: 'OK',
            headerText: 'Proceed?',
            bodyText: 'Perform this action?'
        };

        /* jshint validthis:true */
        this.showModal = function (customModalDefaults, customModalOptions) {
            if (!customModalDefaults) { customModalDefaults = {}; }
            customModalDefaults.backdrop = 'static';
            return this.show(customModalDefaults, customModalOptions);
        };

        /* jshint validthis:true */
        this.show = function (customModalDefaults, customModalOptions) {
            //Create temp objects to work with since we're in a singleton service
            var tempModalDefaults = {};
            var tempModalOptions = {};

            //Map angular-ui modal custom defaults to modal defaults defined in service
            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

            //Map modal.html $scope custom properties to defaults defined in service
            angular.extend(tempModalOptions, modalOptions, customModalOptions);

            if (!tempModalDefaults.controller) {
                tempModalDefaults.controller = function ($scope, $uibModalInstance) {
                    $scope.modalOptions = tempModalOptions;
                    $scope.modalOptions.ok = function (result) {
                        $uibModalInstance.close(result);
                    };
                    $scope.modalOptions.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                };
            }
            return $modal.open(tempModalDefaults).result;

        };

    }
})();